<template>
    <div class="card">
        <div class="card__patch">
            <img :src="mission_patch" alt="">
        </div><!-- /.card__patch -->
        <div class="card__content">
            <router-link tag="h2" :to="{name: 'mission', params: { id: mission.mission_id, mission: mission, launches: launches }}" class="card__title">
                {{mission.mission_name}}
            </router-link><!-- /.card__title -->
            <p class="card__desc">{{mission.description ? mission.description.substring(0, 120) : 'There are no details provided from SpaceX for this launch'}}</p><!-- /.card__desc -->
            <div class="card__icons">
                <div class="card__icon">
                    <img src="../assets/cog.svg" alt="">
                    <span class="card__icon-text">
                        {{mission.manufacturers[0]}}
                    </span><!-- /.card__title -->
                </div><!-- /.card__icon -->
                <a :href="mission.website" class="card__icon card__icon--last">
                    <img src="../assets/world.svg" alt="">
                    <span class="card__icon-text">{{mission.website}}</span><!-- /.card__icon-text -->
                </a><!-- /.card__icon -->
            </div><!-- /.card__icons -->
        </div><!-- /.card__content -->
    </div><!-- /.card -->
</template>

<script>
export default {
    name: 'MissionCard',
    props: {
        mission: Object
    },
    data() {
        return {
            mission_patch: '',
            launches: ''
        }
    },
    methods: {
        findMissionPatch() {
            var res = this.$store.state.launches.filter(i => i.mission_id[0] === this.mission.mission_id || i.mission_id[1] === this.mission.mission_id)[0];
            this.mission_patch = res.links.mission_patch;
        },
        findLatestLaunches() {
            var res = this.$store.state.launches.filter(i => i.mission_id[0] === this.mission.mission_id || i.mission_id[1] === this.mission.mission_id);
            this.launches = res;
        
            
        }
    },
    mounted() {
        this.findMissionPatch();
        this.findLatestLaunches();
    }
}
</script>

